import axios from 'axios';

// Configuração base do axios
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://dark-telegram-server-production.up.railway.app/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Serviços para autenticação
export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Erro ao conectar ao servidor' };
  }
};

// Serviços para Domínios
export const domainService = {
  getAll: () => api.get('/domains'),
  getById: (id) => api.get(`/domains/${id}`),
  create: (domain) => api.post('/domains', domain),
  update: (id, domain) => api.put(`/domains/${id}`, domain),
  delete: (id) => api.delete(`/domains/${id}`)
};

// Serviços para Pixels
export const pixelService = {
  getAll: () => api.get('/pixels').then(response => ({
    data: Array.isArray(response.data) ? response.data : (response.data?.data || [])
  })),
  getById: (id) => api.get(`/pixels/${id}`),
  create: (pixel) => api.post('/pixels', pixel),
  update: (id, pixel) => api.put(`/pixels/${id}`, pixel),
  delete: (id) => api.delete(`/pixels/${id}`),
  testPixel: (pixelData) => axios.post(`${process.env.REACT_APP_PIXEL_SENDER_URL}/pixel/test`, {
    pixelId: pixelData.pixelId,
    accessToken: pixelData.token,
    domain: pixelData.domainId.url || pixelData.domainId,
    viewPage: pixelData.viewPage || pixelData.ViewPage,
    interactedBot: pixelData.InteractedBot || pixelData.interactedBot,
    enteredChannel: pixelData.EnteredChannel || pixelData.enteredChannel
  })
};

// Serviços para DataSets
export const datasetService = {
  getAll: () => api.get('/datasets').then(response => ({
    data: Array.isArray(response.data) ? response.data : (response.data?.data || [])
  })),
  getById: (id) => api.get(`/datasets/${id}`),
  create: (dataset) => api.post('/datasets', dataset).then(response => ({
    data: response.data
  })),
  update: (id, dataset) => api.put(`/datasets/${id}`, dataset).then(response => ({
    data: response.data
  })),
  delete: (id) => api.delete(`/datasets/${id}`),
  validateBotToken: (botToken) => api.post('/datasets/validate-bot', { botToken }).then(response => ({
    data: response.data
  })),
  checkChannel: (data) => api.post('/datasets/check-channel', {
    botToken: data.botToken,
    channelId: data.channelId
  }).then(response => ({
    data: response.data
  })),
  getScript: (id) => api.get(`/datasets/${id}/generate-script`)
};

// Serviços para Métricas
export const metricsService = {
  getDailyMetrics: async (filters) => {
    try {
      const response = await api.get('/dashboard/metrics', { params: filters });
      console.log('[API] Resposta do servidor:', response);
      return response;
    } catch (error) {
      console.error('Erro ao buscar métricas:', error.message);
      throw error;
    }
  },
  getDatasetMetrics: async (datasetId, filters) => {
    try {
      const response = await api.get(`/dashboard/metrics/dataset/${datasetId}`, { params: filters });
      return response;
    } catch (error) {
      console.error('Erro ao buscar métricas do dataset:', error.message);
      throw error;
    }
  }
};

export default api; 